import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { postMultipart } from 'api/fetch';

export const createNewAmbassador = createAsyncThunk(
  'global/AmbassadorOnboarding/createNewAmbassador',
  async (ambassador) => {
    const response = await postMultipart('/affiliate/register', ambassador);
    return response.data;
  }
);

const slice = createSlice({
  name: 'global/AmbassadorOnboarding',
  initialState: {
    isLoading: false,
    error: null,
    success: false,
    company: null
  },
  reducers: {
    updateCompanyInfo: (state, { payload }) => {
      state.company = { ...state.company, ...payload };
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    }
  },
  extraReducers: {
    [createNewAmbassador.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    [createNewAmbassador.fulfilled]: (state) => {
      state.isLoading = false;
      state.success = true;
    },
    [createNewAmbassador.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    }
  }
});

export const { updateCompanyInfo, setLoading } = slice.actions;
export default slice.reducer;
